var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import "./mapDetails.scss";
import "../../features/venueDetails/venueDetails.scss";
import IndoorMapInfo from "./IndoorMapInfo";
import { HDSBreadcrumb, HDSBreadcrumbItem, } from "@here/hds-react-components/Breadcrumb";
import { HDSButton } from "@here/hds-react-components/Button";
import { HDSIcon } from "@here/hds-react-components/Icon";
import { HDSProgressIndicator } from "@here/hds-react-components/ProgressIndicator";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedTab } from "../../store/reducers/appSlice";
import DropDown from "../../components/dropDown/DropDown";
import translations from "../../translations/resources/en-GB.json";
import { deleteMap, createDraft, CheckIn, discardCheckout, } from "../../api/indoorMapOperations";
import { useHistory } from "react-router-dom";
import { setVenue } from "../../store/reducers/venueSlice";
import { ModalPortal } from "../../components/mapModal/ModalPortal";
import { toast } from "@here/hds-notification";
import { breadcrumbClick, discardAnnotations, keepAnnotations } from "./helper";
import { getIconProps } from "../../features/venueDetails/helper";
import { JSIndoorMap } from "../../pages/JsMapCreator/components";
import { ANNOTATION_DISCARD_MODAL, ANNOTATION_MODAL_BUTTON, } from "../../pages/JsMapCreator/constants";
import { setAnnotationPresent, setDiscardAllAnnotations, setShowJSMAPDiscardModal, } from "../../store/reducers/jsMapSlice";
import { useBeforeUnload } from "../../hooks";
import { onCloseEntryModal } from "../../pages/JsMapCreator/helper";
import { PORTAL_TABS } from "../../store/common/constants";
import { ConfirmDailog } from "../../generic-components";
//TO-DO: currently venue is been set through redux state, we can check if the same can be passed as props
var MapDetails = function (props) {
    var _a, _b;
    var venue = props.venue;
    var history = useHistory();
    var dispatch = useDispatch();
    var _c = useState(false), showModal = _c[0], setShowModal = _c[1];
    var selectedTab = useSelector(function (state) { var _a; return (_a = state === null || state === void 0 ? void 0 : state.app) === null || _a === void 0 ? void 0 : _a.selectedTab; });
    var showJSMAPDiscardModal = useSelector(function (state) { var _a; return (_a = state === null || state === void 0 ? void 0 : state.jsMap) === null || _a === void 0 ? void 0 : _a.showJSMAPDiscardModal; });
    var annotationPresent = useSelector(function (state) { var _a; return (_a = state === null || state === void 0 ? void 0 : state.jsMap) === null || _a === void 0 ? void 0 : _a.annotationPresent; });
    var browserModalOptions = { shouldAddEventListener: annotationPresent };
    //default browser modal will be displayed on refresh,
    //tab close, back and forward browser events
    useBeforeUnload(browserModalOptions);
    var is3DViewerEnabled = (_a = venue === null || venue === void 0 ? void 0 : venue.mapDetails) === null || _a === void 0 ? void 0 : _a.isSource3D;
    var viewMapListItems = [
        translations.data["venonboard.internalTools.buttonDeleteMap"],
        translations.data["venonboard.internalTools.buttonCheckOut"],
    ];
    var editMapListItems = [
        translations.data["venonboard.internalTools.buttonDeleteMap"],
        translations.data["venonboard.internalTools.buttonDiscardCheckOut"],
        translations.data["venonboard.internalTools.buttonCheckIn"],
    ];
    var Icon = function () {
        return (_jsx(HDSButton, { variant: "secondary", icon: "overflow-vert-center", size: "medium" }));
    };
    var tabSelected = selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.replace(/([a-z0-9])([A-Z])/g, "$1 $2");
    tabSelected = tabSelected.charAt(0).toUpperCase() + (tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.slice(1));
    var dropDownFunctions = function (mapModal) {
        if (mapModal === translations.data["venonboard.internalTools.buttonDeleteMap"]) {
            dispatch(deleteMap(venue, notify));
            history.goBack();
        }
        else if (mapModal === translations.data["venonboard.internalTools.buttonCheckOut"]) {
            dispatch(createDraft(venue, setShowModal, notify));
        }
        else if (mapModal ===
            translations.data["venonboard.internalTools.buttonDiscardCheckOut"]) {
            dispatch(discardCheckout(venue, notify));
        }
        else if (mapModal === translations.data["venonboard.internalTools.buttonCheckIn"]) {
            dispatch(CheckIn(venue, notify));
        }
    };
    var notify = function (title, body, duration, status, variant) {
        return toast({
            title: title,
            body: body,
            timeout: duration,
            status: status,
            variant: variant,
        });
    };
    useEffect(function () {
        window.addEventListener("popstate", onPopstate);
        return function () {
            window.removeEventListener("popstate", onPopstate);
        };
    });
    var onPopstate = function () {
        dispatch(setVenue(null));
        dispatch(setAnnotationPresent(false));
        dispatch(setDiscardAllAnnotations(true));
    };
    return (_jsx(_Fragment, { children: _jsxs("div", { children: [_jsx(ModalPortal, { children: showModal && (_jsx(ConfirmDailog, __assign({ hideCloseBtn: true, disableCloseOnOverlayClick: true, disableCloseOnEscape: true, header: translations.data["venonboard.internalTools.draftCreation"], footer: _jsx(_Fragment, {}) }, { children: _jsxs("div", __assign({ style: {
                                position: "relative",
                                textAlign: "center",
                                verticalAlign: "middle",
                                overflow: "hidden",
                            } }, { children: [_jsx(HDSProgressIndicator, { variant: "indeterminate", indicatorType: "circular", size: "large", color: "accent", style: { position: "relative", left: "48%" } }), _jsx("p", { children: translations.data["venonboard.internalTools.CreateDraftMessage"] })] })) }))) }), _jsx(ModalPortal, { children: showJSMAPDiscardModal && (_jsx(ConfirmDailog, __assign({ hideCloseBtn: false, disableCloseOnOverlayClick: true, disableCloseOnEscape: true, onClose: function () {
                            onCloseEntryModal(), dispatch(setShowJSMAPDiscardModal(false));
                            dispatch(setSelectedTab(PORTAL_TABS.INDOOR_MAP));
                        }, header: "Your update requests hasn\u2019t been added yet.", footer: _jsxs("div", __assign({ style: {
                                display: "flex",
                                gap: "10px",
                                justifyContent: "flex-end",
                                overflow: "hidden",
                            } }, { children: [_jsx(HDSButton, __assign({ variant: "secondary", onClick: function () { return dispatch(discardAnnotations()); }, size: "small" }, { children: _jsx("div", { children: ANNOTATION_MODAL_BUTTON.DISCARD }) })), _jsx(HDSButton, __assign({ variant: "primary", onClick: function () { return dispatch(keepAnnotations()); }, size: "small" }, { children: ANNOTATION_MODAL_BUTTON.KEEP }))] })) }, { children: _jsx("div", { children: _jsx("p", { children: ANNOTATION_DISCARD_MODAL.MESSAGE }) }) }))) }), _jsx("div", __assign({ className: "breadCrumbContainer" }, { children: _jsxs(HDSBreadcrumb, { children: [_jsx(HDSBreadcrumbItem, __assign({ style: { display: "flex", justifyContent: "center" } }, { children: _jsx("a", __assign({ onClick: function () { return dispatch(breadcrumbClick()); } }, { children: tabSelected })) })), _jsx(HDSBreadcrumbItem, __assign({ active: true, style: { display: "flex", justifyContent: "center" } }, { children: venue === null || venue === void 0 ? void 0 : venue.name }))] }) })), _jsxs("div", __assign({ style: {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    } }, { children: [_jsxs("div", __assign({ className: "mapDetailsHeadline" }, { children: [_jsxs("div", __assign({ style: { height: "50px" } }, { children: [_jsx("div", { className: is3DViewerEnabled ? "ellipse3d" : "ellipse" }), _jsx("div", __assign({ className: "mapIcon" }, { children: _jsx(HDSIcon, __assign({}, getIconProps(is3DViewerEnabled))) }))] })), _jsx("div", __assign({ className: "indoorMapTitle" }, { children: venue === null || venue === void 0 ? void 0 : venue.name }))] })), selectedTab === PORTAL_TABS.INTERNAL_TOOLS && (_jsx("div", __assign({ style: { display: "flex", flexDirection: "row", gap: "10px" } }, { children: _jsx(DropDown, { itemList: (venue === null || venue === void 0 ? void 0 : venue.draftStatus) ===
                                    translations.data["venonboard.internalTools.chipStatusCheckout"]
                                    ? editMapListItems
                                    : viewMapListItems, trigger: _jsx(Icon, {}), displayListItemIcon: false, onChange: dropDownFunctions }) })))] })), _jsx(JSIndoorMap, { indoorMapId: (_b = venue === null || venue === void 0 ? void 0 : venue.id) === null || _b === void 0 ? void 0 : _b.toString(), venue: venue }), _jsx(IndoorMapInfo, {})] }) }));
};
export default MapDetails;
